const PREFIX = '@S11//';

export const CHANGE_PAGE_TITLE = `${PREFIX}CHANGE-PAGE-TITLE`;
export const TOGGLE_DRAWER = `${PREFIX}TOGGLE_DRAWER`;



